// extracted by mini-css-extract-plugin
export default {"deactivateMFA":"EmployeeBannerComponent_deactivateMFA__oUE2i"};